import { Avatar, Button, CircularProgress, Grid } from '@material-ui/core';
import { min } from 'date-fns';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import CustomUserMenu from '../../commons/CustomUserMenu';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AdaugaEmailuri from './AdaugaEmailuri';
import ListaEmailuri from './ListaEmailuri';
import ListaEvaluatori from './ListaEvaluatori';
import WsC from './providers/WsC';


export default class EvaluareNouaGenerala extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            tipEvaluare: 0,
            tipuriEvaluare: this.u.tipuriEvaluare,
            departamente: [],
            chestionare: [],
            userEvaluat: {
                id: null, poza: null
            },
            useri: [],
            openList: false,
            departamentSelectat: 0,
            formularSelectat: 0,
            angajatiSelectati: 0,
            angajatiSelectatiSefi: 0,
            creeazaEvaluareDisabled: true,
            chestionarSelectat: 0,
            idxDepartament: -1,
            ultimaEvaluare: null,
            objMin: {},
            emailuriEvaluare: [],
            emailuriToate: [],
            openAdaugaEmailuri: false,
            emailNou: { nume: '', email: '' },
            maxClienti: 10,
            disabledAdministrareClienti: false,
            disabledTip: false,
            disabledDepartamente: false,
            disabeldFormular: false,
            emailuriSelectate: 0,
            popUpDepartamente: false,
            idxUserEvaluat: -1,
            emailuriAll: [],
            departamenteAll: [],
            initiazaEvaluarea: false,
            loading:false,
            alertView:false,
            idSocietate:0

        }
    }


    u = new Utils()
    wsC = new WsC()
    ws = new Ws()
    ls = new LocalStorage().GetUserData()
    departamenteAll = []

    componentDidMount() {
        this.access()
        this.getData()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    getData = async () => {

        let getSocietate = await this.ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        if (getSocietate.Succes) {
            let _departamente = this.ws.customSelect(`select d.id, d.poza, d.nume, d.[level], d.id_parent, o.[margintop], o.[marginleft], o.[width],
        o.[height], o.color from departamente d left outer join organigrama_display_data o
         on (d.id = o.id_departament) where isnull(d.inactiv,0) != @p1 and marginLeft > 0 `, {
                p1: 1
            })


            let _departamenteAll = this.ws.customSelect(`select d.id, d.poza, d.nume, d.[level], d.id_parent, o.[margintop], o.[marginleft], o.[width],
        o.[height], o.color from departamente d left outer join organigrama_display_data o
         on (d.id = o.id_departament) where isnull(d.inactiv,0) != @p1 and marginLeft > 0 `, {
                p1: 1
            })


            let _angajati = this.ws.customSelect(`select
                        a.id , dep.id as id_departament, u.id as id_user,
                        l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
                        ad.sef_departament,a.cnp,a.adresa,a.telefon,
                        a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.doc_fisa_postului,a.cv, u.email, u.firma, u.is_admin, dep.nume as nume_departament  from  useri u
                        left join angajati a on u.id = a.id_user 
                        left join angajati_departamente ad on ad.id_angajat = a.id
                        left join departamente dep on dep.id = ad.id_departament
                        left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
                        where isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
            })


            let chestionare = await this.wsC.customSelect(`select u.nume as nume_utilizator,  c.* , (select count(*) from chestionare_intrebari where id_chestionar = c.id and isnull(id_parent,0) = 0) as nr_intrebari 
        from chestionare c left join [${this.ls.InfoUser.Database}].[dbo].[useri] u on c.creat_de = u.id  where c.baza_date = @p1 and isnull(c.sters,0) != 1`,
                { p1: this.ls.InfoUser.Database })





            let emailuriToate = await this.wsC.customSelect(`select * from evaluari_emailuri where baza_date = @p1 and isnull(sters,0) != 1`, {
                p1: this.ls.InfoUser.Database
            })


            // let updateEmailuri = await this.wsC.update(`evaluari_emailuri`,{sters:1} ,{
            //   id_evaluare:0
            // })


            let [d, dAll, a, c, emA] = await Promise.all([_departamente, _departamenteAll, _angajati, chestionare, emailuriToate])
            console.log('d :>> ', d);
            console.log('a :>> ', a);

            if (d.Succes && a.Succes && c.Succes && emA.Succes) {

                console.log('useri :>> ', a.Content);

                let cloneA = [...a.Content]



                let emailuri = []

                let rez = []

                let depts = [...d.Content]

                let deptsAll = [...dAll.Content]

                let counter = depts.length

                let counter2 = deptsAll.length

                let userEvaluat = {}

                let useriEvaluatori = []

                let angajatiSelectati = this.state.angajatiSelectati


                for (let j = 0; j < counter; j++) {

                    let angajati = cloneA.filter(a => a.id_departament === depts[j].id)





                    for (let k = 0, m = angajati.length; k < m; k++) {

                        useriEvaluatori.push(angajati[k])

                        let idx = emailuri.findIndex(email => email.id_angajat === angajati[k].id)

                        angajati[k].emailuri = []
                        angajati[k].evaluatori = []

                        if (idx !== -1) {
                            angajati[k].selectat = true
                        } else {

                            angajati[k].selectat = false
                        }




                        angajati[k].disabled = false

                    }


                    depts[j].selectat = false
                    depts[j].expandat = false
                    depts[j].angajati = angajati




                }




                console.log('depts :>> ', depts);



                console.log('userEvaluat :>> ', userEvaluat);

                depts = depts.filter(dept => dept.angajati.length > 0)


                let emailuriAll = [...emA.Content]

                let uniqueEmailuri = []

                console.log('emailuri :>> ', emailuri);

                for (let i = 0, n = emailuriAll.length; i < n; i++) {

                    if (uniqueEmailuri.length > 0) {
                        let idx = uniqueEmailuri.findIndex(u => u.email === emailuriAll[i].email)

                        if (idx === -1) {

                            emailuriAll[i].checked = false


                            uniqueEmailuri.push(emailuriAll[i])

                        }
                    } else {



                        emailuriAll[i].checked = false
                        uniqueEmailuri.push(emailuriAll[i])


                    }


                }


                for (let i = 0, n = emailuri.length; i < n; i++) {

                    let idx = uniqueEmailuri.findIndex(item => item.email === emailuri[i].email)

                    if (idx !== -1) {
                        uniqueEmailuri.splice(idx, 1)
                    }
                }

                console.log('uniqueEmailuri :>> ', uniqueEmailuri);



                console.log('depts :>> ', depts);
                console.log('useriEvaluatori :>> ', useriEvaluatori);


                this.setState({
                    departamente: depts,
                    departamenteAll: deptsAll,
                    userEvaluat: {
                        id: 0,
                        id_user: 0,
                        nume: "",
                        poza: null,
                    },
                    useri: useriEvaluatori,
                    chestionare: c.Content,
                    tipEvaluare: Number(this.props.match.params.idevaluare) !== 0 ? 1 : 0,
                    emailuriToate: uniqueEmailuri,
                    emailuriEvaluare: [],
                    angajatiSelectati: angajatiSelectati,
                    disabledAdministrareClienti: emailuri === 10,
                    disabledTip: false,
                    disabledDepartamente: false,
                    disabeldFormular: false,
                    emailuriAll: uniqueEmailuri,
                    idSocietate:getSocietate.Content[0].val
                })








                // this.setState({
                //     departamente: depts,
                //     userEvaluat: userEvaluat,
                //     chestionarSelectat: e.Content[0].id_chestionar,
                //     useri: useriEvaluatori,
                //     chestionare: c.Content,
                //     tipEvaluare: Number(this.props.match.params.idevaluare) !== 0 ? 1 : 0,
                //     evaluare: e.Content[0],
                //     emailuriEvaluare: emailuri,
                //     angajatiSelectati: angajatiSelectati,
                //     creeazaEvaluareDisabled: false,
                //     emailuriToate: uniqueEmailuri,
                //     disabledAdministrareClienti: emailuri === 10,
                //     disabledTip: true,
                //     disabledDepartamente: true,
                //     disabeldFormular: true
                // })



            }
        }
    }


    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }


    changeTipEvaluare = async (ev) => {


        let val = ev.target.value

        let disabled = true

        console.log('val :>> ', val);




        let cloneUseri = [...this.state.useri]

        let useriIds = cloneUseri.map((u, idx) => {
            return u.id_user
        })

        console.log('cloneUseri :>> ', cloneUseri);

        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_user_aprobare in (${useriIds}) order by e.cand_creat desc`,
            { p1: 1 })

        console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);


        let emailuri = [...this.state.emailuriToate]

        for (let i = 0, n = emailuri.length; i < n; i++) {
            emailuri[i].checked = false
        }

        let departamente = [...this.state.departamente]


        for(let i = 0 , n = departamente.length; i < n ; i++){

            for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){

              
                    departamente[i].angajati[j].disabled = false
                
            }
        }


        if (getUltimaEvaluare.Succes) {
            this.setState({
                tipEvaluare: val,
                creeazaEvaluareDisabled: disabled,
                departamente:departamente,
                ultimaEvaluare: getUltimaEvaluare.Content[0],
                emailuriToate: emailuri,
                emailuriEvaluare: [],
                popUpDepartamente: Number(val) > 1 ? true : false,
                userEvaluat: {
                    id: null, poza: null
                },
            })
        }




    }

    changeDepartament = async (ev) => {
        let val = ev.target.value

        let disabled = true

        if (Number(this.state.chestionarSelectat) > 0) {
            disabled = false
        }


        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_departament = @p1 and isnull(e.inactiv,0) != 1 order by e.cand_creat desc`, {
            p1: val
        })

        let idx = this.state.departamente.findIndex(d => Number(d.id) === Number(val))

        if (getUltimaEvaluare.Succes) {
            console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);
            this.setState({
                departamentSelectat: val,
                creeazaEvaluareDisabled: disabled,
                idxDepartament: idx,
                ultimaEvaluare: getUltimaEvaluare.Content[0]
            })
        }


    }


    selectUser = async (u) => {

        let disabled = true

        if (Number(this.state.chestionarSelectat) > 0) {
            disabled = false
        }

        console.log('this.state.chestionarSelectat :>> ', this.state.chestionarSelectat);
        console.log('disabled :>> ', disabled);



        let idx = this.state.departamente.findIndex(d => d.id === u.id_departament)


        let getUltimaEvaluare = await this.wsC.customSelect(`select e.*, (select count(*) from evaluari_emailuri where id_evaluare = e.id) as nr_evaluatori from evaluari e where e.id_user_aprobare = @p1 order by e.cand_creat desc`, { p1: u.id_user })

        console.log('getUltimaEvaluare :>> ', getUltimaEvaluare);



        let departamente = [...this.state.departamente]


        for(let i = 0 , n = departamente.length; i < n ; i++){

            for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){

                if( Number(departamente[i].angajati[j].id_user) === Number(u.id_user) ){

                        departamente[i].angajati[j].disabled = true
                }else{
                    departamente[i].angajati[j].disabled = false
                }
            }
        }

        if (getUltimaEvaluare.Succes) {
            this.setState({
                userEvaluat: u,
                idxDepartament: idx,
                creeazaEvaluareDisabled: disabled,
                ultimaEvaluare: getUltimaEvaluare.Content[0]
            })

        }


    }


    changeChestionar = async (ev) => {

        let val = ev.target.value
        let disabled = true

        if (this.state.userEvaluat.id) {
            disabled = false
        } else if (Number(this.state.departamentSelectat) > 0) {
            disabled = false
        } else if (Number(this.state.tipEvaluare) === 3) {
            disabled = false
        }

        console.log('this.state.userEvaluat :>> ', this.state.userEvaluat);
        console.log('disabled :>> ', disabled);


        let updateSesiuneCo = this.wsC.update('sesiuni', { id_chestionar: val }, { id: this.props.match.params.idsesiunecolegi })
        let updateSesiuneS = this.wsC.update('sesiuni', { id_chestionar: val }, { id: this.props.match.params.idsesiunesefi })
        let updateSesiuneCl = this.wsC.update('sesiuni', { id_chestionar: val }, { id: this.props.match.params.idsesiuneclienti })


        let [uCo, uS, uCl] = await Promise.all([updateSesiuneCo, updateSesiuneS, updateSesiuneCl])

        if (uCo.Succes && uS.Succes && uCl.Succes) {
            this.setState({
                chestionarSelectat: val,
                creeazaEvaluareDisabled: disabled
            })
        }


    }


    goToChestionare = () => {
        this.props.history.push('/chestionareevaluari')
    }

    selecteazaDepartament = (d, tip) => {

        let departamente = [...this.state.departamente]

        let angajatiSelectati = this.state.angajatiSelectati

        let angajatiSelectatiSefi = this.state.angajatiSelectatiSefi

        let idx = departamente.findIndex(dep => dep.id === d.id)

        console.log('departamente :>> ', departamente[idx]);

        if (idx !== -1) {

            departamente[idx]['selectat'] = !departamente[idx]['selectat']
            departamente[idx]['expandat'] = departamente[idx]['selectat']



            for (let i = 0, n = departamente[idx].angajati.length; i < n; i++) {

                if (!departamente[idx].angajati[i]['disabled']) {


                if (departamente[idx].angajati[i]['selectat'] !== departamente[idx]['selectat']) {
                    departamente[idx].angajati[i]['selectat'] = departamente[idx]['selectat']

                  
                        if (departamente[idx].angajati[i]['selectat']) {

                            if (tip === 'angajati') {

                                angajatiSelectati += 1
                            } else {
                                angajatiSelectatiSefi += 1
                            }
                        } else {
                            if (tip === 'angajati') {

                                angajatiSelectati -= 1
                            } else {
                                angajatiSelectatiSefi -= 1
                            }

                        }
                    }
                


                }




            }

            console.log('angajatiSelectati :>> ', angajatiSelectati);






        }

        this.setState({
            departamente: departamente,
            angajatiSelectati: angajatiSelectati,
            angajatiSelectatiSefi: angajatiSelectatiSefi
        })
    }



    selecteazaAngajat = (a, tip) => {

        let departamente = [...this.state.departamente]

        let angajatiSelectati = this.state.angajatiSelectati

        let angajatiSelectatiSefi = this.state.angajatiSelectatiSefi

        let idxDep = departamente.findIndex(dep => dep.id === a.id_departament)

        console.log('idxDep :>> ', idxDep);

        console.log('a :>> ', a);
        if (idxDep !== -1) {
            let idxA = departamente[idxDep].angajati.findIndex(ang => ang.id === a.id)

            if (idxA !== -1) {

                if (!departamente[idxDep].angajati[idxA]['disabled']) {
                departamente[idxDep].angajati[idxA]['selectat'] = !departamente[idxDep].angajati[idxA]['selectat']
                if (!departamente[idxDep].angajati[idxA]['selectat'] === false) {

                    if (tip === 'angajati') {

                        angajatiSelectati += 1
                    } else {
                        angajatiSelectatiSefi += 1
                    }


                } else {
                    if (tip === 'angajati') {

                        angajatiSelectati -= 1
                        departamente[idxDep]['selectat'] = false
                    } else {
                        angajatiSelectatiSefi -= 1
                        departamente[idxDep]['selectat'] = false
                    }


                }

                let filterDep = departamente[idxDep].angajati.filter(ang => ang.selectat)


                console.log('filterDep :>> ', filterDep);
                if (departamente[idxDep].angajati.length === filterDep.length) {
                    departamente[idxDep]['selectat'] = true
                }

            }

            }

            this.setState({
                angajatiSelectati: angajatiSelectati,
                angajatiSelectatiSefi: angajatiSelectatiSefi,
                departamente: departamente
            })
        }

    }


    arataUseri = (d) => {
        let departamente = [...this.state.departamente]

        let idx = departamente.findIndex(dep => dep.id === d.id)

        if (idx !== -1) {

            departamente[idx]['expandat'] = !departamente[idx]['expandat']



            this.setState({ listaDepartamente: departamente })
        }
    }









    addEvaluare = async () => {


        this.setState({loading:true}, async()=>{
            if (Number(this.state.tipEvaluare) === 1) {

                console.log('addEvaluare :>> ',);
    
    
                let objEvaluareColegi = {
                    id_beneficiar: this.state.idSocietate,
                    cand_creat: this.u.updateSqlNow(),
                    cine_creat: this.ls.InfoUser.IdUser,
                    denumire: "",
                    foloseste_puncte: 1,
                    id_sesiune: this.props.match.params.idsesiunecolegi,
                    id_user_aprobare: this.state.userEvaluat.id_user,
                    statusul: "lansat",
                    tip: "evaluare_angajati",
                    id_departament: this.state.userEvaluat.id_departament,
                }
    
                let objEvaluareSefi = {
                    id_beneficiar: this.state.idSocietate,
                    cand_creat: this.u.updateSqlNow(),
                    cine_creat: this.ls.InfoUser.IdUser,
                    denumire: "",
                    foloseste_puncte: 1,
                    id_sesiune: this.props.match.params.idsesiunesefi,
                    id_user_aprobare: this.state.userEvaluat.id_user,
                    statusul: "lansat",
                    tip: "evaluare_sefi",
                    id_departament: this.state.userEvaluat.id_departament,
                }
    
                let objEvaluareClienti = {
                    id_beneficiar: this.state.idSocietate,
                    cand_creat: this.u.updateSqlNow(),
                    cine_creat: this.ls.InfoUser.IdUser,
                    denumire: "",
                    foloseste_puncte: 1,
                    id_sesiune: this.props.match.params.idsesiuneclienti,
                    id_user_aprobare: this.state.userEvaluat.id_user,
                    statusul: "lansat",
                    tip: "evaluare_clienti",
                    id_departament: this.state.userEvaluat.id_departament,
                }
    
                //evaluare colegi
    
                let insertEvaluareCo = await this.wsC.insert('evaluari', objEvaluareColegi)
    
                if (insertEvaluareCo.Succes) {
    
                    let evaluareChestionarCo = {
                        id_evaluare: insertEvaluareCo.Content[0].id,
                        id_chestionar: this.state.chestionarSelectat
                    }
    
                    let departamente = [...this.state.departamente]
    
                    let evaluatoriCo = []
    
                    for (let i = 0, n = departamente.length; i < n; i++) {
    
                        for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {
    
                            if (departamente[i].angajati[j].selectat) {
    
    
                                if (departamente[i].angajati[j].sef_departament !== 1) {
                                    evaluatoriCo.push(departamente[i].angajati[j])
                                }
    
                            }
                        }
                    }
    
    
                    let insertLegaturaChestionarEvaluareCo = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCo)
    
                    console.log('insertLegaturaChestionarEvaluareCo :>> ', insertLegaturaChestionarEvaluareCo);
    
                    if (insertLegaturaChestionarEvaluareCo.Succes) {
    
                        for (let i = 0, n = evaluatoriCo.length; i < n; i++) {
    
    
    
    
                            let objToAdd = {
                                id_beneficiar: this.state.idSocietate,
                                id_evaluare: insertEvaluareCo.Content[0].id,
                                email: evaluatoriCo[i].email,
                                nume: evaluatoriCo[i].nume,
                                id_departament: evaluatoriCo[i].id_departament,
                                id_angajat: evaluatoriCo[i].id
                            }
                            console.log('objToAdd :', objToAdd);
    
                            let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
    
                            // console.warn('insert :>> ', insert);
    
    
    
                        }
    
    
                    }
    
                    let sendEmailsCo = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCo.Content[0].id, isFromPm:'1' })
    
                }
    
    
    
    
                /// evaluare sefi
                let insertEvaluareS = await this.wsC.insert('evaluari', objEvaluareSefi)
    
    
                if (insertEvaluareS.Succes) {
                    let evaluareChestionarS = {
                        id_evaluare: insertEvaluareS.Content[0].id,
                        id_chestionar: this.state.chestionarSelectat
                    }
    
                    let departamente = [...this.state.departamente]
                    let evaluatoriS = []
    
    
                    for (let i = 0, n = departamente.length; i < n; i++) {
    
                        for (let j = 0, m = departamente[i].angajati.length; j < m; j++) {
    
                            if (departamente[i].angajati[j].selectat) {
    
    
                                if (departamente[i].angajati[j].sef_departament === 1) {
                                    evaluatoriS.push(departamente[i].angajati[j])
                                }
    
                            }
                        }
                    }
    
                    let insertLegaturaChestionarEvaluareS = await this.wsC.insert('evaluari_chestionare', evaluareChestionarS)
    
                    if (insertLegaturaChestionarEvaluareS.Succes) {
    
                        for (let i = 0, n = evaluatoriS.length; i < n; i++) {
    
    
    
    
                            let objToAdd = {
                                id_beneficiar: this.state.idSocietate,
                                id_evaluare: insertEvaluareS.Content[0].id,
                                email: evaluatoriS[i].email,
                                nume: evaluatoriS[i].nume,
                                id_departament: evaluatoriS[i].id_departament,
                                id_angajat: evaluatoriS[i].id
                            }
                            console.log('objToAdd :', objToAdd);
    
                            let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
    
                            // console.warn('insert :>> ', insert);
    
    
    
                        }
    
    
                        let sendEmailsS = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareS.Content[0].id, isFromPm:'1' })
    
                    }
    
                }
    
    
    
                ///evaluare clienti
    
    
                let insertEvaluareCl = await this.wsC.insert('evaluari', objEvaluareClienti)
    
    
                if (insertEvaluareCl.Succes) {
    
                    let evaluareChestionarCl = {
                        id_evaluare: insertEvaluareCl.Content[0].id,
                        id_chestionar: this.state.chestionarSelectat
                    }
    
                    let emailuri = [...this.state.emailuriEvaluare]
    
    
                    let insertLegaturaChestionarEvaluareCl = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCl)
    
                    if (insertLegaturaChestionarEvaluareCl.Succes) {
                        for (let i = 0, n = emailuri.length; i < n; i++) {
    
    
    
    
                            let objToAdd = {
                                id_beneficiar: this.state.idSocietate,
                                id_evaluare: insertEvaluareCl.Content[0].id,
                                email: emailuri[i].email,
                                nume: emailuri[i].nume,
                                id_departament: '',
                                id_angajat: '',
                                baza_date: this.ls.InfoUser.Database
                            }
                            console.log('objToAdd :', objToAdd);
    
                            let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
    
                            // console.warn('insert :>> ', insert);
    
    
    
                        }
    
    
    
    
                        let sendEmailsCl = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCl.Content[0].id, isFromPm:'1' })
                    }
    
    
    
    
                }
    
    
                this.props.history.push(`/evaluarigenerale`)
    
            } else if (Number(this.state.tipEvaluare) === 2) {
    
    
                console.log('insertEvaluare  departamente:>> ');
    
                let departamente = [...this.state.departamente]
    
    
                let idxDepartament = departamente.findIndex(dep=> Number(dep.id) === Number(this.state.departamentSelectat))
    
                console.log('idxDepartament :>> ', idxDepartament);
    
    
    
                if(idxDepartament !== -1){
    
    
    //evaluare colegi
                    for(let i = 0 ,n = departamente[idxDepartament].angajati.length; i< n ; i++ ){

                    
                            let objEvaluareColegi = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiunecolegi,
                                id_user_aprobare: departamente[idxDepartament].angajati[i].id_user,
                                statusul: "lansat",
                                tip: "evaluare_angajati",
                                id_departament: departamente[idxDepartament].angajati[i].id_departament,
                            }
        
                            let insertEvaluareCo = await this.wsC.insert('evaluari', objEvaluareColegi)
        
                            console.log('insertEvaluareCo :>> ', insertEvaluareCo);
                
                            if (insertEvaluareCo.Succes) {
                
                                let evaluareChestionarCo = {
                                    id_evaluare: insertEvaluareCo.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }
                
                       
                
                                let evaluatoriCo = departamente[idxDepartament].angajati[i].evaluatori.filter(evl=> evl.sef_departament !== 1)
                
                
                
                                let insertLegaturaChestionarEvaluareCo = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCo)
                
                                console.log('insertLegaturaChestionarEvaluareCo :>> ', insertLegaturaChestionarEvaluareCo);
                
                                if (insertLegaturaChestionarEvaluareCo.Succes) {
                
                                    for (let j = 0, n = evaluatoriCo.length; j < n; j++) {
                
                
                
                
                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluareCo.Content[0].id,
                                            email: evaluatoriCo[j].email,
                                            nume: evaluatoriCo[j].nume,
                                            id_departament: evaluatoriCo[j].id_departament,
                                            id_angajat: evaluatoriCo[j].id
                                        }
                                        console.log('objToAdd :', objToAdd);
                
                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
                
                                        // console.warn('insert :>> ', insert);
                
                
                
                                    }
                
                
                                }
                
                                let sendEmailsCo = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCo.Content[0].id, isFromPm:'1' })
                
                            }
                        
    
                      
    
                    }
    ///end evaluare colegi
    
    
    
    // evaluare sefi
    
      
    for(let i = 0 , n = departamente[idxDepartament].angajati.length; i< n ; i++){

      
            let objEvaluareSefi = {
                id_beneficiar: this.state.idSocietate,
                cand_creat: this.u.updateSqlNow(),
                cine_creat: this.ls.InfoUser.IdUser,
                denumire: "",
                foloseste_puncte: 1,
                id_sesiune: this.props.match.params.idsesiunesefi,
                id_user_aprobare: departamente[idxDepartament].angajati[i].id_user,
                statusul: "lansat",
                tip: "evaluare_sefi",
                id_departament: departamente[idxDepartament].angajati[i].id_departament,
            }
        
            let insertEvaluareS = await this.wsC.insert('evaluari', objEvaluareSefi)
        
        
            if (insertEvaluareS.Succes) {
                let evaluareChestionarS = {
                    id_evaluare: insertEvaluareS.Content[0].id,
                    id_chestionar: this.state.chestionarSelectat
                }
        
            
                let evaluatoriS =  departamente[idxDepartament].angajati[i].evaluatori.filter(evl=> evl.sef_departament === 1)
        
        
               
        
                let insertLegaturaChestionarEvaluareS = await this.wsC.insert('evaluari_chestionare', evaluareChestionarS)
        
                if (insertLegaturaChestionarEvaluareS.Succes) {
        
                    for (let j = 0, n = evaluatoriS.length; j < n; j++) {
        
        
        
        
                        let objToAdd = {
                            id_beneficiar: this.state.idSocietate,
                            id_evaluare: insertEvaluareS.Content[0].id,
                            email: evaluatoriS[j].email,
                            nume: evaluatoriS[j].nume,
                            id_departament: evaluatoriS[j].id_departament,
                            id_angajat: evaluatoriS[j].id
                        }
                        console.log('objToAdd :', objToAdd);
        
                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
        
                        // console.warn('insert :>> ', insert);
        
        
        
                    }
        
        
                    let sendEmailsS = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareS.Content[0].id, isFromPm:'1' })
        
                }
        
            }
        
       
    
    }
    
    ////end evaluare sefi
    
    
    // evaluare clienti
    
                    for(let i = 0 , n = departamente[idxDepartament].angajati.length; i< n ; i++){
    
    
                 

                                let objEvaluareClienti = {
                                    id_beneficiar: this.state.idSocietate,
                                    cand_creat: this.u.updateSqlNow(),
                                    cine_creat: this.ls.InfoUser.IdUser,
                                    denumire: "",
                                    foloseste_puncte: 1,
                                    id_sesiune: this.props.match.params.idsesiuneclienti,
                                    id_user_aprobare: departamente[idxDepartament].angajati[i].id_user,
                                    statusul: "lansat",
                                    tip: "evaluare_clienti",
                                    id_departament: departamente[idxDepartament].angajati[i].id_departament,
                                }

                            

                                let insertEvaluareCl = await this.wsC.insert('evaluari', objEvaluareClienti)


                                if (insertEvaluareCl.Succes) {

                                    let evaluareChestionarCl = {
                                        id_evaluare: insertEvaluareCl.Content[0].id,
                                        id_chestionar: this.state.chestionarSelectat
                                    }

                                    let emailuri = departamente[idxDepartament].angajati[i].emailuri


                                    let insertLegaturaChestionarEvaluareCl = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCl)

                                    if (insertLegaturaChestionarEvaluareCl.Succes) {
                                        for (let j = 0, n = emailuri.length; j < n; j++) {




                                            let objToAdd = {
                                                id_beneficiar: this.state.idSocietate,
                                                id_evaluare: insertEvaluareCl.Content[0].id,
                                                email: emailuri[j].email,
                                                nume: emailuri[j].nume,
                                                id_departament: '',
                                                id_angajat: '',
                                                baza_date: this.ls.InfoUser.Database
                                            }
                                            console.log('objToAdd :', objToAdd);

                                            let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);

                                            // console.warn('insert :>> ', insert);



                                        }




                                    }
                                    
                                    let sendEmailsCl = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCl.Content[0].id, isFromPm:'1' })



                                }

                            
             
    
                      
                    }
                }
    
                this.props.history.push(`/evaluarigenerale`)
            }else {
    
    
                let departamente = [...this.state.departamente]
    
               
    
    
                for(let u = 0 , p = departamente.length; u < p ; u++){
                    for(let i = 0 , n = departamente[u].angajati.length; i< n ; i++){


                       

                            let objEvaluareColegi = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiunecolegi,
                                id_user_aprobare: departamente[u].angajati[i].id_user,
                                statusul: "lansat",
                                tip: "evaluare_angajati",
                                id_departament: departamente[u].angajati[i].id_departament,
                            }
                
                            let objEvaluareSefi = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiunesefi,
                                id_user_aprobare: departamente[u].angajati[i].id_user,
                                statusul: "lansat",
                                tip: "evaluare_sefi",
                                id_departament: departamente[u].angajati[i].id_departament,
                            }
                
                            let objEvaluareClienti = {
                                id_beneficiar: this.state.idSocietate,
                                cand_creat: this.u.updateSqlNow(),
                                cine_creat: this.ls.InfoUser.IdUser,
                                denumire: "",
                                foloseste_puncte: 1,
                                id_sesiune: this.props.match.params.idsesiuneclienti,
                                id_user_aprobare: departamente[u].angajati[i].id_user,
                                statusul: "lansat",
                                tip: "evaluare_clienti",
                                id_departament: departamente[u].angajati[i].id_departament,
                            }
                
                            // evaluare colegi
                
                            let insertEvaluareCo = await this.wsC.insert('evaluari', objEvaluareColegi)
                
                            console.log('insertEvaluareCo :>> ', insertEvaluareCo);
                
                            if (insertEvaluareCo.Succes) {
                
                                let evaluareChestionarCo = {
                                    id_evaluare: insertEvaluareCo.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }
                
                       
                
                                let evaluatoriCo = departamente[u].angajati[i].evaluatori.filter(evl=> evl.sef_departament !== 1)
                
                
                
                                let insertLegaturaChestionarEvaluareCo = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCo)
                
                                console.log('insertLegaturaChestionarEvaluareCo :>> ', insertLegaturaChestionarEvaluareCo);
                
                                if (insertLegaturaChestionarEvaluareCo.Succes) {
                
                                    for (let j = 0, n = evaluatoriCo.length; j < n; j++) {
                
                
                
                
                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluareCo.Content[0].id,
                                            email: evaluatoriCo[j].email,
                                            nume: evaluatoriCo[j].nume,
                                            id_departament: evaluatoriCo[j].id_departament,
                                            id_angajat: evaluatoriCo[j].id
                                        }
                                        console.log('objToAdd :', objToAdd);
                
                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
                
                                        // console.warn('insert :>> ', insert);
                
                
                
                                    }
                
                
                                }
                
                                let sendEmailsCo = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCo.Content[0].id, isFromPm:'1' })
                
                            }
                
                            // evaluare sefi 
                
                
                            let insertEvaluareS = await this.wsC.insert('evaluari', objEvaluareSefi)
                
                
                            if (insertEvaluareS.Succes) {
                                let evaluareChestionarS = {
                                    id_evaluare: insertEvaluareS.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }
                
                            
                                let evaluatoriS =  departamente[u].angajati[i].evaluatori.filter(evl=> evl.sef_departament === 1)
                
                
                               
                
                                let insertLegaturaChestionarEvaluareS = await this.wsC.insert('evaluari_chestionare', evaluareChestionarS)
                
                                if (insertLegaturaChestionarEvaluareS.Succes) {
                
                                    for (let j = 0, n = evaluatoriS.length; j < n; j++) {
                
                
                
                
                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluareS.Content[0].id,
                                            email: evaluatoriS[j].email,
                                            nume: evaluatoriS[j].nume,
                                            id_departament: evaluatoriS[j].id_departament,
                                            id_angajat: evaluatoriS[j].id
                                        }
                                        console.log('objToAdd :', objToAdd);
                
                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
                
                                        // console.warn('insert :>> ', insert);
                
                
                
                                    }
                
                
                                    let sendEmailsS = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareS.Content[0].id, isFromPm:'1' })
                
                                }
                
                            }
                
                
                            // evaluare clienti
                
                            let insertEvaluareCl = await this.wsC.insert('evaluari', objEvaluareClienti)
                
                
                            if (insertEvaluareCl.Succes) {
                
                                let evaluareChestionarCl = {
                                    id_evaluare: insertEvaluareCl.Content[0].id,
                                    id_chestionar: this.state.chestionarSelectat
                                }
                
                                let emailuri = departamente[u].angajati[i].emailuri
                
                
                                let insertLegaturaChestionarEvaluareCl = await this.wsC.insert('evaluari_chestionare', evaluareChestionarCl)
                
                                if (insertLegaturaChestionarEvaluareCl.Succes) {
                                    for (let j = 0, n = emailuri.length; j < n; j++) {
                
                
                
                
                                        let objToAdd = {
                                            id_beneficiar: this.state.idSocietate,
                                            id_evaluare: insertEvaluareCl.Content[0].id,
                                            email: emailuri[j].email,
                                            nume: emailuri[j].nume,
                                            id_departament: '',
                                            id_angajat: '',
                                            baza_date: this.ls.InfoUser.Database
                                        }
                                        console.log('objToAdd :', objToAdd);
                
                                        let insert = await this.wsC.insert('evaluari_emailuri', objToAdd);
                
                                        // console.warn('insert :>> ', insert);
                
                
                
                                    }
                
                
                
                
                                    let sendEmailsCl = await this.wsC.getData('Evaluari/SendMassEmails', { idEvaluare: insertEvaluareCl.Content[0].id, isFromPm:'1' })
                                }
                
                
                
                
                            }

                        
    
    
    
                      
            
            
            
            
                            }
                    
    
                }
    
                this.props.history.push(`/evaluarigenerale`)
            }
            
        })



       



    }


    changeEmail = (ev) => {
        let val = ev.target.value
        let n = ev.target.name

        let oldObj = { ...this.state.emailNou }

        oldObj[n] = val

        this.setState({ emailNou: oldObj })
    }


    adaugaEmailNou = async () => {

        let email = { ...this.state.emailNou }
        let emailuriE = [...this.state.emailuriEvaluare]
        let emailuriToate = [...this.state.emailuriToate]
        let emailuriSelectate = this.state.emailuriSelectate

        console.log('email :>> ', email);
        console.log('emailuriE :>> ', emailuriE);




        if (emailuriToate.length > 0) {
            let idx = emailuriToate.findIndex(e => e.email === email.email)

            if (idx === -1) {

                if (this.state.emailuriEvaluare.length < this.state.maxClienti) {

                    email.checked = true

                    emailuriE.push(email)
                    // emailuriToate.push(email)

                    console.log('emailuriToate :>> ', emailuriToate);

                    this.setState({
                        emailuriEvaluare: emailuriE,
                        emailuriToate: emailuriToate,
                        emailNou: { nume: '', email: '' },
                        emailuriSelectate: emailuriSelectate + 1
                    })

                }

            }
        } else {

            email.checked = true

            emailuriE.push(email)
            // emailuriToate.push(email)

            console.log('emailuriToate :>> ', emailuriToate);

            this.setState({
                emailuriEvaluare: emailuriE,
                emailuriToate: emailuriToate,
                emailNou: { nume: '', email: '' },
                emailuriSelectate: emailuriSelectate + 1
            })
        }







    }


    selecteazaEmail = (e) => {

        let emailuriToate = [...this.state.emailuriToate]

        let emailuriSelectate = this.state.emailuriSelectate

        console.log('emailuriSelectate :>> ', emailuriSelectate);

        let idx = emailuriToate.findIndex(em => em.email === e.email)

        if (idx !== -1) {

            if (emailuriSelectate < 10) {

                if (!emailuriToate[idx].checked === false) {
                    emailuriSelectate -= 1
                } else {
                    emailuriSelectate += 1
                }
                emailuriToate[idx].checked = !emailuriToate[idx].checked


            } else {
                if (!emailuriToate[idx].checked === false) {
                    emailuriToate[idx].checked = !emailuriToate[idx].checked
                    emailuriSelectate -= 1
                }
            }

            this.setState({
                emailuriToate: emailuriToate,
                emailuriSelectate: emailuriSelectate
            })

        }
    }


    adaugaClienti = () => {

        let emailuriToate = [...this.state.emailuriToate]

        let emailuriEvaluare = [...this.state.emailuriEvaluare]


        for (let i = 0, n = emailuriToate.length; i < n; i++) {

            if (emailuriToate[i].checked) {
                emailuriEvaluare.push(emailuriToate[i])
            }
        }


        for (let i = 0, n = emailuriEvaluare.length; i < n; i++) {
            let idx = emailuriToate.findIndex(item => item.email === emailuriEvaluare[i].email)

            if (idx !== -1) {
                emailuriToate.splice(idx, 1)
            }
        }


        this.setState({
            emailuriToate: emailuriToate,
            emailuriEvaluare: emailuriEvaluare
        })
    }


    deleteEmail = (e) => {

        console.log('e :>> ', e);

        console.log('this.props.match.params.idevaluare :>> ', this.props.match.params.idevaluare);

     


            console.log('e :>> ', e);

            let emailuriToate = [...this.state.emailuriToate]

            let emailuriEvaluare = [...this.state.emailuriEvaluare]

            let emailuriSelectate = this.state.emailuriSelectate

            console.log('emailuriSelectate :>> ', emailuriSelectate);


            let idx = emailuriEvaluare.findIndex(item => item.email === e.email)

            if (idx !== -1) {

                emailuriEvaluare[idx].checked = false

                emailuriToate.push(emailuriEvaluare[idx])
                emailuriEvaluare.splice(idx, 1)

                emailuriSelectate -= 1


                this.setState({
                    emailuriSelectate: emailuriSelectate,
                    emailuriToate: emailuriToate,
                    emailuriEvaluare: emailuriEvaluare
                })
            }
        
    }

    urmatorulUserEvaluareComp = async () => {

        let idxUserEvaluat = this.state.idxUserEvaluat + 1

      let departamente = [...this.state.departamente]

        let userEvaluat = {}

        let emailuriSelectate = 0

        let angajati = [...this.state.useri]

        

       


        if (idxUserEvaluat < angajati.length) {

            if (idxUserEvaluat > 0) {
                angajati[idxUserEvaluat - 1].emailuri = this.state.emailuriEvaluare

                

                    for (let q = 0, m = angajati.length; q < m; q++) {

                        if (angajati[q].selectat) {

                            let idxEval = angajati[idxUserEvaluat - 1].evaluatori.findIndex(evl=> evl.id ===  angajati[q].id)

                            if(idxEval === -1){

                                angajati[idxUserEvaluat - 1].evaluatori.push(angajati[q])
                            }
                        }
                    }
                
            }

            userEvaluat = angajati[idxUserEvaluat]



            let emailuriToate = [...this.state.emailuriAll]

            for (let i = 0, n = userEvaluat.emailuri; i < n; i++) {



                let idxEmailuri = emailuriToate.findIndex(item => item.email === userEvaluat.emailuri[i].email)

                if (idxEmailuri !== -1) {
                    emailuriToate.splice(idxEmailuri, 1)
                }
            }


            for (let i = 0, n = emailuriToate.length; i < n; i++) {
                emailuriToate[i].checked = false
            }


            emailuriSelectate = userEvaluat.emailuri.length



                for (let k = 0, m = angajati.length; k < m; k++) {

                    let idxAng = angajati[idxUserEvaluat].evaluatori.findIndex(evl => evl.id_user === angajati[k].id_user)

                    if (idxAng !== -1) {
                        angajati[k].selectat = true
                    } else {
                        angajati[k].selectat = false
                    }

                }


               
       


                for(let i = 0 , n = departamente.length; i < n ; i++){
        
                    for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){
        
                        if( Number(departamente[i].angajati[j].id_user) === Number(userEvaluat.id_user) ){
        
                                departamente[i].angajati[j].disabled = true
                        }else{
                            departamente[i].angajati[j].disabled = false
                        }
                    }
                }

            

            console.log('object :>> ', userEvaluat.emailuri);
            this.setState({
                userEvaluat: userEvaluat,
                idxUserEvaluat: idxUserEvaluat,
                emailuriEvaluare: userEvaluat.emailuri || [],
                emailuriToate: emailuriToate,
                emailuriSelectate: emailuriSelectate,
                disabledTip: true,
                disabledDepartamente: true,
                disabeldFormular: true,
                departamente:departamente,
                useri: angajati,
                angajatiSelectati: angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament !== 1).length,
                angajatiSelectatiSefi: angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament === 1).length,
                initiazaEvaluarea: false

            })

        } else {

            console.log('Trimite emailuri :>> ',);

            angajati[idxUserEvaluat - 1].emailuri = this.state.emailuriEvaluare

        

                for (let q = 0, m = angajati.length; q < m; q++) {

                    if (angajati[q].selectat) {
                       angajati[idxUserEvaluat - 1].evaluatori.push(angajati[q])
                    }
                }
            

            this.setState({
                useri: angajati,
                initiazaEvaluarea: true,
                departamente:departamente,
            })
        }
    }


    inapoiUserEvaluareComp = () => {
        let angajati = [...this.state.useri]

        let departamente = [...this.state.departamente]

        let idxUserEvaluat = this.state.idxUserEvaluat - 1

        let userEvaluat = {}

        let emailuriSelectate = 0





        if (idxUserEvaluat > -1) {

            userEvaluat = angajati[idxUserEvaluat]

            angajati[idxUserEvaluat + 1].emailuri = this.state.emailuriEvaluare


            for (let q = 0, m = angajati.length; q < m; q++) {

                if (angajati[q].selectat) {

                    let idxEval = angajati[idxUserEvaluat + 1].evaluatori.findIndex(evl=> evl.id ===  angajati[q].id)

                    if(idxEval === -1){

                        angajati[idxUserEvaluat + 1].evaluatori.push(angajati[q])
                    }

                }
            }

            let emailuriToate = [...this.state.emailuriAll]

            for (let i = 0, n = userEvaluat.emailuri; i < n; i++) {

                userEvaluat.emailuri[i].checked = false

                let idxEmailuri = emailuriToate.findIndex(item => item.email === userEvaluat.emailuri[i].email)

                if (idxEmailuri !== -1) {
                    emailuriToate.splice(idxEmailuri, 1)
                }
            }


            for (let i = 0, n = emailuriToate.length; i < n; i++) {
                emailuriToate[i].checked = false
            }


            emailuriSelectate = userEvaluat.emailuri.length

            for (let k = 0, m = angajati.length; k < m; k++) {

                let idxAng = angajati[idxUserEvaluat].evaluatori.findIndex(evl => evl.id_user === angajati[k].id_user)

                if (idxAng !== -1) {
                    angajati[k].selectat = true
                } else {
                    angajati[k].selectat = false
                }

            }

            for(let i = 0 , n = departamente.length; i < n ; i++){
        
                for(let j = 0 , m = departamente[i].angajati.length ; j< m;  j++){
    
                    if( Number(departamente[i].angajati[j].id_user) === Number(userEvaluat.id_user) ){
    
                            departamente[i].angajati[j].disabled = true
                    }else{
                        departamente[i].angajati[j].disabled = false
                    }
                }
            }


            this.setState({
                userEvaluat: userEvaluat,
                idxUserEvaluat: idxUserEvaluat,
                emailuriEvaluare: angajati[idxUserEvaluat].emailuri,
                emailuriSelectate: emailuriSelectate,
                useri: angajati,
                departamente:departamente,
                angajatiSelectati: angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament !== 1).length,
                angajatiSelectatiSefi: angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament === 1).length,
                initiazaEvaluarea: false
            })

        } else {
            this.setState({
                userEvaluat: {
                    id: null, poza: null
                },
                idxUserEvaluat: idxUserEvaluat,
                emailuriEvaluare: [],
                emailuriSelectate: emailuriSelectate,
                disabledTip: false,
                disabledDepartamente: false,
                disabeldFormular: false,
                useri: angajati,
                departamente:departamente,
                angajatiSelectati: 0,
                angajatiSelectatiSefi: 0,
                initiazaEvaluarea: false,

            })
        }



    }


    goToUser = (a) =>{

        let departamente = [...this.state.departamente]

        let angajati = [...this.state.useri]

        let idxUserEvaluat = 0

        let idx = departamente.findIndex(dep => Number(dep.id) === Number(this.state.departamentSelectat))


        if(Number(this.state.tipEvaluare) === 2){
            if(idx !== -1){

                let idxA = departamente[idx].angajati.findIndex(ang => ang.id === a.id)
    
    
                if(idxA !== -1){
                    idxUserEvaluat = idxA - 1
    
                    this.setState({idxUserEvaluat:idxUserEvaluat},()=>{
    
                  
    
                            this.urmatorulUserEvaluare()
                       
                    })
                }
    
            }
        }else{
            let idxA = angajati.findIndex(ang => ang.id === a.id)
    
    
            if(idxA !== -1){
                idxUserEvaluat = idxA - 1

                this.setState({idxUserEvaluat:idxUserEvaluat},()=>{

              

                        this.urmatorulUserEvaluareComp()
                   
                })
            }

        }


        
    }



 


    urmatorulUserEvaluare = async () => {

        let departamente = [...this.state.departamente]

        let departamenteAll = [...this.state.departamenteAll]

        let idxUserEvaluat = this.state.idxUserEvaluat + 1

        let userEvaluat = {}

        let emailuriSelectate = 0


        let idx = departamente.findIndex(dep => Number(dep.id) === Number(this.state.departamentSelectat))




        if (idx !== -1) {
            if (idxUserEvaluat < departamente[idx].angajati.length) {

                if (idxUserEvaluat > 0) {
                    departamente[idx].angajati[idxUserEvaluat - 1].emailuri = this.state.emailuriEvaluare

                    for (let i = 0, n = departamente.length; i < n; i++) {

                        for (let q = 0, m = departamente[i].angajati.length; q < m; q++) {

                            if (departamente[i].angajati[q].selectat) {

                                let idxEval = departamente[idx].angajati[idxUserEvaluat - 1].evaluatori.findIndex(evl=> evl.id ===  departamente[i].angajati[q].id)

                                if(idxEval === -1){

                                    departamente[idx].angajati[idxUserEvaluat - 1].evaluatori.push(departamente[i].angajati[q])
                                }
                            }
                        }
                    }

                }

                userEvaluat = departamente[idx].angajati[idxUserEvaluat]



                let emailuriToate = [...this.state.emailuriAll]



                for (let i = 0, n = userEvaluat.emailuri.length; i < n; i++) {



                    let idxEmailuri = emailuriToate.findIndex(item => item.email === userEvaluat.emailuri[i].email)

                    if (idxEmailuri !== -1) {
                        emailuriToate.splice(idxEmailuri, 1)
                    }
                }




                for (let i = 0, n = emailuriToate.length; i < n; i++) {
                    emailuriToate[i].checked = false
                }








                emailuriSelectate = userEvaluat.emailuri.length





                for (let j = 0, n = departamente.length; j < n; j++) {


                    for (let k = 0, m = departamente[j].angajati.length; k < m; k++) {

                        let idxAng = departamente[idx].angajati[idxUserEvaluat].evaluatori.findIndex(evl => evl.id_user === departamente[j].angajati[k].id_user)

                        if (idxAng !== -1) {
                            departamente[j].angajati[k].selectat = true
                        } else {
                            departamente[j].angajati[k].selectat = false
                        }


                        if(Number(departamente[j].angajati[k].id_user) === Number(userEvaluat.id_user) ){
                            departamente[j].angajati[k].disabled = true
                        }else{
                            departamente[j].angajati[k].disabled = false
                        }

                    }


                    departamente[j].selectat = false
                    departamente[j].expandat = false


                }


                console.log('departamenteAll :>> ', departamente);


                console.log('departamente[idx].angajati[idxUserEvaluat].evaluatori :>> ', departamente[idx].angajati[idxUserEvaluat].evaluatori);

                console.log('object :>> ', userEvaluat.emailuri);
                this.setState({
                    userEvaluat: userEvaluat,
                    idxUserEvaluat: idxUserEvaluat,
                    emailuriEvaluare: userEvaluat.emailuri || [],
                    emailuriToate: emailuriToate,
                    emailuriSelectate: emailuriSelectate,
                    disabledTip: true,
                    disabledDepartamente: true,
                    disabeldFormular: true,
                    departamente: departamente,
                    departamenteAll: departamenteAll,
                    angajatiSelectati: departamente[idx].angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament !== 1).length,
                    angajatiSelectatiSefi: departamente[idx].angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament === 1).length,
                    initiazaEvaluarea: false
                })

            } else {
                console.log('Trimite emailuri :>> ',);

                departamente[idx].angajati[idxUserEvaluat - 1].emailuri = this.state.emailuriEvaluare

                for (let i = 0, n = departamente.length; i < n; i++) {

                    for (let q = 0, m = departamente[i].angajati.length; q < m; q++) {

                        if (departamente[i].angajati[q].selectat) {
                            departamente[idx].angajati[idxUserEvaluat - 1].evaluatori.push(departamente[i].angajati[q])
                        }
                    }
                }

                this.setState({
                    departamente:departamente,
                    initiazaEvaluarea: true
                })


            }
        }

        console.log('departament :>> ', departamente);

    }

    inapoiUserEvaluare = () => {
        let departamente = [...this.state.departamente]

        let departamenteAll = [...this.state.departamenteAll]

        let idxUserEvaluat = this.state.idxUserEvaluat - 1

        let userEvaluat = {}

        let emailuriSelectate = 0

        let idx = departamente.findIndex(dep => Number(dep.id) === Number(this.state.departamentSelectat))




        if (idx !== -1) {
            if (idxUserEvaluat > -1) {

                userEvaluat = departamente[idx].angajati[idxUserEvaluat]

                departamente[idx].angajati[idxUserEvaluat + 1].emailuri = this.state.emailuriEvaluare


                for (let i = 0, n = departamente.length; i < n; i++) {

                    for (let q = 0, m = departamente[i].angajati.length; q < m; q++) {

                        if (departamente[i].angajati[q].selectat) {

                            let idxEval = departamente[idx].angajati[idxUserEvaluat + 1].evaluatori.findIndex(evl=> evl.id ===  departamente[i].angajati[q].id)

                            if(idxEval === -1){

                                departamente[idx].angajati[idxUserEvaluat + 1].evaluatori.push(departamente[i].angajati[q])
                            }

                        }
                    }
                }

                let emailuriToate = [...this.state.emailuriAll]

                for (let i = 0, n = userEvaluat.emailuri.length; i < n; i++) {

                    userEvaluat.emailuri[i].checked = false

                    let idxEmailuri = emailuriToate.findIndex(item => item.email === userEvaluat.emailuri[i].email)

                    if (idxEmailuri !== -1) {
                        emailuriToate.splice(idxEmailuri, 1)
                    }
                }


                for (let i = 0, n = emailuriToate.length; i < n; i++) {
                    emailuriToate[i].checked = false
                }


                emailuriSelectate = userEvaluat.emailuri.length



                for (let j = 0, n = departamente.length; j < n; j++) {


                    for (let k = 0, m = departamente[j].angajati.length; k < m; k++) {

                        let idxAng = departamente[idx].angajati[idxUserEvaluat].evaluatori.findIndex(evl => evl.id_user === departamente[j].angajati[k].id_user)

                        if (idxAng !== -1) {
                            departamente[j].angajati[k].selectat = true
                        } else {
                            departamente[j].angajati[k].selectat = false
                        }

                        if(Number(departamente[j].angajati[k].id_user) === Number(userEvaluat.id_user) ){
                            departamente[j].angajati[k].disabled = true
                        }else{
                            departamente[j].angajati[k].disabled = false
                        }
                    }


                    departamente[j].selectat = false
                    departamente[j].expandat = false


                }


                console.log('departamente :>> ', departamente);





                this.setState({
                    userEvaluat: userEvaluat,
                    idxUserEvaluat: idxUserEvaluat,
                    emailuriEvaluare: departamente[idx].angajati[idxUserEvaluat].emailuri,
                    emailuriSelectate: emailuriSelectate,
                    departamente: departamente,
                    angajatiSelectati: departamente[idx].angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament !== 1).length,
                    angajatiSelectatiSefi: departamente[idx].angajati[idxUserEvaluat].evaluatori.filter(comp => comp.sef_departament === 1).length,
                    initiazaEvaluarea: false
                    // departamenteAll:departamenteAll
                })

            } else {
                this.setState({
                    userEvaluat: {
                        id: null, poza: null
                    },
                    idxUserEvaluat: idxUserEvaluat,
                    emailuriEvaluare: [],
                    emailuriSelectate: emailuriSelectate,
                    disabledTip: false,
                    disabledDepartamente: false,
                    disabeldFormular: false,
                    departamente: departamente,
                    angajatiSelectati: 0,
                    angajatiSelectatiSefi: 0,
                    initiazaEvaluarea: false,

                })
            }
        }


    }

    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={''} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }

                <AdaugaEmailuri
                    open={this.state.openAdaugaEmailuri}
                    dialogClose={() => { this.setState({ openAdaugaEmailuri: false }) }}
                    email={this.state.emailNou}
                    emailuriToate={this.state.emailuriToate}
                    emailuriEvaluare={this.state.emailuriEvaluare}
                    changeEmail={this.changeEmail}
                    adaugaEmail={this.adaugaEmailNou}
                    angajatiSelectati={this.state.angajatiSelectati}
                    adaugaClienti={this.adaugaClienti}
                    selecteazaEmail={this.selecteazaEmail}
                    deleteEmail={this.deleteEmail}
                />

                <Grid style={{ maxWidth: 1200, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.evaluari.evaluareGenerala}</h1>
                    </Grid>



                    {this.state.popUpDepartamente &&
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle', display: 'flex' }} className='material-icons'>error</i>
                                    <span style={{ fontSize: 11, fontWeight: 500, display: 'flex' }}>
                                    {this.dictionary.evaluari.mesajEvaluareClienti}
                               
                                        </span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpDepartamente: false }) }} className='material-icons'>clear</i>
                                </div>

                            </div>
                        </Grid>
                    }


                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>


                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5  className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.peCineEvaluezi}</h5>
                                </Grid>
                                <Grid style={{ marginBottom: 20, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='tip-evaluare'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='tva'
                                            value={this.state.tipEvaluare}
                                            onChange={this.changeTipEvaluare}
                                            placeholder={this.dictionary.evaluari.alegeOptiune}
                                            disabled={this.state.disabledTip}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeOptiune}</option>
                                            {this.state.tipuriEvaluare.map((t, idx) => {
                                                return (
                                                    <option key={idx} value={t.id}>{t.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label>
                                    </div>
                                </Grid>

                                {Number(this.state.tipEvaluare) === 1 &&
                                    <Grid style={{ marginBottom: 20, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div>
                                            <CustomUserMenu
                                                user={this.state.userEvaluat}
                                                clearInput={() => {
                                                    this.setState({
                                                        userEvaluat: Number(this.props.match.params.idevaluare) !== 0 ?
                                                            this.state.userEvaluat :

                                                            {
                                                                id: null, poza: null
                                                            },
                                                        creeazaEvaluareDisabled: false
                                                    })
                                                }}
                                                openList={() => { this.setState({ openList: true }) }}
                                                closeList={() => { this.setState({ openList: false }) }}
                                                showList={this.state.openList}
                                                users={this.state.useri}
                                                selectUser={this.selectUser}

                                            />
                                        </div>

                                    </Grid>
                                }

                                {Number(this.state.tipEvaluare) === 2 &&
                                    <Grid style={{ marginBottom: 20, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                id='departament'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                value={this.state.departamentSelectat}
                                                onChange={this.changeDepartament}
                                                placeholder={this.dictionary.evaluari.alegeDepartament}
                                                disabled={this.state.disabledDepartamente}
                                            >

                                                <option value={0}>{this.dictionary.evaluari.alegeDepartament}</option>
                                                {this.state.departamente.map((d, idx) => {
                                                    return (
                                                        <option key={idx} value={d.id}>{d.nume}</option>
                                                    )
                                                })}
                                            </select>
                                            <label  className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label>
                                        </div>
                                    </Grid>
                                }

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.formularEvaluare}</h5>
                                </Grid>
                                <Grid style={{ marginBottom: 10, textAlign:'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id='chestionar'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='tva'
                                            value={this.state.chestionarSelectat}
                                            onChange={this.changeChestionar}
                                            placeholder={this.dictionary.evaluari.alegeFormular}
                                            disabled={this.state.disabeldFormular}
                                        >

                                            <option value={0}>{this.dictionary.evaluari.alegeFormular}</option>
                                            {this.state.chestionare.map((d, idx) => {
                                                return (
                                                    <option key={idx} value={d.id}>{d.titlu}</option>
                                                )
                                            })}
                                        </select>
                                        <label  className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.alegeFormular}</label>
                                    </div>
                                </Grid>
                                <Grid style={{ marginBottom: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span style={{ textAlign: 'left', fontSize: 12 }} >
                                        <span onClick={this.goToChestionare} style={{ textDecoration: 'underline', cursor: 'pointer', color: 'rgb(25 87 169)' }}>{this.dictionary.evaluari.clickAici}</span> {this.dictionary.evaluari.administrareFormulare}</span>


                                </Grid>

                                {Number(this.state.tipEvaluare) === 1 &&
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            disabled={this.state.creeazaEvaluareDisabled}
                                            className={this.state.creeazaEvaluareDisabled ? 'add-button-disabled' : 'add-button-green'}
                                             onClick={this.addEvaluare}  >

                                        {this.dictionary.evaluari.creeazaEvaluarea}
                                         </Button>
                                    </Grid>
                                }

                                {Number(this.state.tipEvaluare) === 2 &&
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        {!this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.creeazaEvaluareDisabled}
                                                className={this.state.creeazaEvaluareDisabled ? 'add-button-disabled' : 'add-button-green'} onClick={this.urmatorulUserEvaluare}  >

                                        {this.dictionary.evaluari.creeazaEvaluarea}
                                         </Button>
                                        }


                                        {this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.idxDepartament <= 0}
                                                className={this.state.idxDepartament <= 0 ? 'add-button-disabled' : 'add-button-green'} onClick={this.inapoiUserEvaluare}  >

                                            {this.dictionary.evaluari.inapoi}       
                                         </Button>
                                        }

                                        {this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.emailuriEvaluare.length === 0}
                                                style={{marginLeft:20}}
                                                className={this.state.emailuriEvaluare.length === 0 ? 'add-button-disabled' : 'add-button-green'} onClick={this.urmatorulUserEvaluare}  >


                                            {this.dictionary.evaluari.urmatorulEvaluat}
                                         </Button>
                                        }

                                        {this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.emailuriEvaluare.length === 0}
                                                className={this.state.emailuriEvaluare.length === 0 ? 'add-button-disabled' : 'add-button-green'} onClick={this.addEvaluare}  >


                                            {this.dictionary.evaluari.initiazaEvaluarea}
                                         </Button>
                                        }

                                    </Grid>
                                }


                                {Number(this.state.tipEvaluare) === 3 &&
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        {!this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.creeazaEvaluareDisabled}
                                                className={this.state.creeazaEvaluareDisabled ? 'add-button-disabled' : 'add-button-green'} onClick={this.urmatorulUserEvaluareComp}  >

                                            {this.dictionary.evaluari.creeazaEvaluarea}
                                         </Button>
                                        }


                                        {this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.idxUserEvaluat <= -1}
                                                className={this.state.idxUserEvaluat <= -1 ? 'add-button-disabled' : 'add-button-green'} onClick={this.inapoiUserEvaluareComp}  >

                                            {this.dictionary.evaluari.inapoi}  
                                         </Button>
                                        }

                                        {this.state.userEvaluat.id && !this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.emailuriEvaluare.length === 0}
                                                style={{marginLeft:20}}

                                                className={this.state.emailuriEvaluare.length === 0 ? 'add-button-disabled' : 'add-button-green'} onClick={this.urmatorulUserEvaluareComp}  >

                                                {this.dictionary.evaluari.urmatorulEvaluat}
                                         </Button>
                                        }


                                        {this.state.initiazaEvaluarea &&
                                            <Button
                                                disabled={this.state.emailuriEvaluare.length === 0}
                                                className={this.state.emailuriEvaluare.length === 0 ? 'add-button-disabled' : 'add-button-green'} onClick={this.addEvaluare}  >


                                            {this.dictionary.evaluari.initiazaEvaluarea}
                                         </Button>
                                        }

                                    </Grid>
                                }


                            </Grid>
                        </Grid>

                        {!this.state.initiazaEvaluarea &&
                            <Grid style={{ padding: '0px 40px 0px 40px' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                {Number(this.state.tipEvaluare) === 1 &&
                                    <Grid container>







                                        {/* evaluare colegi */}
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.selecteazaEvaluatori}</h5>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <ListaEvaluatori
                                                    arataUseri={this.arataUseri}
                                                    listaDepartamente={this.state.departamente}
                                                    selecteazaDepartament={this.selecteazaDepartament}
                                                    selecteazaAngajat={this.selecteazaAngajat}
                                                    tip={'evaluari_angajati'}
                                                />
                                            </Grid>

                                            <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.angajatiSelectati}</span> {this.dictionary.evaluari.din} {this.state.useri.filter(u => u.sef_departament !== 1).length } {this.dictionary.evaluari.evaluatoriSelectati}</span>
                                            </Grid>
                                        </Grid>




                                        {/* evaluare sefi */}
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.selecteazaManageriEvaluatori}</h5>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <ListaEvaluatori
                                                    arataUseri={this.arataUseri}
                                                    listaDepartamente={this.state.departamente}
                                                    selecteazaDepartament={this.selecteazaDepartament}
                                                    selecteazaAngajat={this.selecteazaAngajat}
                                                    tip={'evaluari_sefi'}
                                                />
                                            </Grid>

                                            <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.angajatiSelectatiSefi}</span> {this.dictionary.evaluari.din} {this.state.useri.filter(u => u.sef_departament === 1).length } {this.dictionary.evaluari.evaluatoriSelectati}</span>
                                            </Grid>
                                        </Grid>








                                        {/* evaluare clienti */}
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginBottom: 10 }} >{this.dictionary.evaluari.selecteazaClientiEvaluatori}</h5>
                                                </Grid>

                                                {this.state.emailuriEvaluare.length > 0 &&
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <ListaEmailuri
                                                            emailuri={this.state.emailuriEvaluare}
                                                            emailuriToate={false}
                                                            deleteEmail={this.deleteEmail}

                                                        />
                                                    </Grid>
                                                }


                                                {this.state.emailuriEvaluare.length === 0 &&
                                                    <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <span>{this.dictionary.evaluari.tipEvaluareClientiMesaj}  </span>
                                                    </Grid>
                                                }

                                                {this.state.emailuriEvaluare.length === 0 &&
                                                    <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Button
                                                            disabled={!this.state.userEvaluat.id}
                                                            className={!this.state.userEvaluat.id ? 'add-button-disabled' : 'add-button-blue'}
                                                            style={{ marginTop: 20 }} onClick={() => { this.setState({ openAdaugaEmailuri: true }) }}  >
                                                            <i style={{ marginRight: 10 }} className='material-icons pm-round-button-text'>person_add</i>
                                                  {this.dictionary.evaluari.adaugaClienti} 
                                             </Button>
                                                    </Grid>
                                                }

                                                {this.state.emailuriEvaluare.length > 0 &&
                                                    <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Button
                                                            disabled={!this.state.userEvaluat.id}
                                                            className={!this.state.userEvaluat.id ? 'add-button-disabled' : 'add-button-blue'}
                                                            style={{ marginTop: 20 }} onClick={() => { this.setState({ openAdaugaEmailuri: true }) }}  >
                                                            <i style={{ marginRight: 10 }} className='material-icons pm-round-button-text'>person_add</i>
                                                 {this.dictionary.evaluari.administrareClienti} 
                                             </Button>
                                                    </Grid>
                                                }

                                                {this.state.emailuriEvaluare.length > 0 &&
                                                    <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.emailuriEvaluare.length}</span> {this.dictionary.evaluari.din10Evaluatori} </span>
                                                    </Grid>
                                                }

                                            </Grid>

                                        </Grid>
                                    </Grid>
                                }

                                {Number(this.state.tipEvaluare) >= 2 &&

                                    <Grid container>


                                        {this.state.userEvaluat.id &&
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{paddingLeft:0}} className='pm-custom-user-select-option'  >
                                                    <div>
                                                        {
                                                            this.state.userEvaluat.poza &&
                                                            <div
                                                                className='pm-angajati-picture'
                                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + this.state.userEvaluat.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                            </div>
                                                        }
                                                        {!this.state.userEvaluat.poza &&

                                                            <Avatar
                                                                className='pm-angajati-picture'
                                                                style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(this.state.userEvaluat.id) }}>
                                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                <i className='material-icons'>person</i>
                                                            </Avatar>
                                                            // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                        }
                                                        <span className='pm-custom-user-select-text'>{this.state.userEvaluat.nume}</span>
                                                    </div>

                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        paddingRight: 3
                                                    }}>

                                                    </div>




                                                </div>
                                            </Grid>
                                        }





                                        {!this.state.userEvaluat.id && Number(this.state.tipEvaluare) === 2 && this.state.idxDepartament > -1 && !this.state.initiazaEvaluarea &&

                                            <Grid container>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <h5 style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.lucratoriDepartament}</h5>
                                                </Grid>

                                                {this.state.departamente[this.state.idxDepartament].angajati.map((a, idxA) => {
                                                    return (
                                                        <Grid key={idxA} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <div style={{paddingLeft:0}} className='pm-custom-user-select-option'  >
                                                                <div>
                                                                    {
                                                                        a.poza &&
                                                                        <div
                                                                            className='pm-angajati-picture'
                                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + a.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                                        </div>
                                                                    }
                                                                    {!a.poza &&

                                                                        <Avatar
                                                                            className='pm-angajati-picture'
                                                                            style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(a.id) }}>
                                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                            {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                            <i className='material-icons'>person</i>
                                                                        </Avatar>
                                                                        // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                    }
                                                                    <span className='pm-custom-user-select-text'>{a.nume}</span>
                                                                </div>

                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    paddingRight: 3
                                                                }}>

                                                                </div>




                                                            </div>
                                                        </Grid>
                                                    )
                                                })}

                                            </Grid>



                                        }

                                                {!this.state.userEvaluat.id && Number(this.state.tipEvaluare) === 3  && !this.state.initiazaEvaluarea &&

                                                <Grid container>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.lucratoriCompanie}</h5>
                                                    </Grid>

                                                    {this.state.useri.map((a, idxA) => {
                                                        return (
                                                            <Grid key={idxA} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <div style={{paddingLeft:0}} className='pm-custom-user-select-option'  >
                                                                    <div>
                                                                        {
                                                                            a.poza &&
                                                                            <div
                                                                                className='pm-angajati-picture'
                                                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + a.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                                            </div>
                                                                        }
                                                                        {!a.poza &&

                                                                            <Avatar
                                                                                className='pm-angajati-picture'
                                                                                style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(a.id) }}>
                                                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                                {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                                <i className='material-icons'>person</i>
                                                                            </Avatar>
                                                                            // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                        }
                                                                        <span className='pm-custom-user-select-text'>{a.nume}</span>
                                                                    </div>

                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        paddingRight: 3
                                                                    }}>

                                                                    </div>




                                                                </div>
                                                            </Grid>
                                                        )
                                                    })}

                                                </Grid>



                                                }
                                        {/* evaluare colegi */}
                                        {this.state.userEvaluat.id &&
                                            <Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.evaluari.selecteazaEvaluatori}</h5>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <ListaEvaluatori
                                                        arataUseri={this.arataUseri}
                                                        listaDepartamente={this.state.departamente}
                                                        selecteazaDepartament={this.selecteazaDepartament}
                                                        selecteazaAngajat={this.selecteazaAngajat}
                                                        tip={'evaluari_angajati'}
                                                    />
                                                </Grid>

                                                <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.angajatiSelectati}</span> {this.dictionary.evaluari.din} {this.state.useri.filter(u => u.sef_departament !== 1).length} {this.dictionary.evaluari.evaluatoriSelectati}</span>
                                                </Grid>
                                            </Grid>
                                        }



                                        {/* evaluare sefi */}
                                        {this.state.userEvaluat.id &&
                                            < Grid container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.selecteazaManageriEvaluatori}</h5>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <ListaEvaluatori
                                                        arataUseri={this.arataUseri}
                                                        listaDepartamente={this.state.departamente}
                                                        selecteazaDepartament={this.selecteazaDepartament}
                                                        selecteazaAngajat={this.selecteazaAngajat}
                                                        tip={'evaluari_sefi'}
                                                    />
                                                </Grid>

                                                <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.angajatiSelectatiSefi}</span> {this.dictionary.evaluari.din} {this.state.useri.filter(u => u.sef_departament === 1).length} {this.dictionary.evaluari.evaluatoriSelectati}</span>
                                                </Grid>
                                            </Grid>

                                        }



                                        {/* evaluare clienti  */}

                                        {this.state.userEvaluat.id &&
                                            <Grid item item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                < Grid container>

                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginBottom: 0 }} >{this.dictionary.evaluari.selecteazaClienti}</h5>
                                                    </Grid>






                                                    <Grid container>

                                                        {this.state.emailuriEvaluare.length > 0 &&
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <ListaEmailuri
                                                                    emailuri={this.state.emailuriEvaluare}
                                                                    emailuriToate={false}
                                                                    deleteEmail={this.deleteEmail}

                                                                />
                                                            </Grid>
                                                        }


                                                        {this.state.emailuriEvaluare.length === 0 &&
                                                            <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <span>{this.dictionary.evaluari.tipEvaluareClientiMesaj} </span>
                                                            </Grid>
                                                        }

                                                        {this.state.emailuriEvaluare.length === 0 &&
                                                            <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Button
                                                                    disabled={!this.state.userEvaluat.id}
                                                                    className={!this.state.userEvaluat.id ? 'add-button-disabled' : 'add-button-blue'}
                                                                    style={{ marginTop: 20 }} onClick={() => { this.setState({ openAdaugaEmailuri: true }) }}  >
                                                                    <i style={{ marginRight: 10 }} className='material-icons pm-round-button-text'>person_add</i>
                                                                    {this.dictionary.evaluari.adaugaClienti}
                                             </Button>
                                                            </Grid>
                                                        }

                                                        {this.state.emailuriEvaluare.length > 0 &&
                                                            <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <Button
                                                                    disabled={!this.state.userEvaluat.id}
                                                                    className={!this.state.userEvaluat.id ? 'add-button-disabled' : 'add-button-blue'}
                                                                    style={{marginTop: 20 }} onClick={() => { this.setState({ openAdaugaEmailuri: true }) }}  >
                                                                    <i style={{ marginRight: 10 }} className='material-icons pm-round-button-text'>person_add</i>
                                                 {this.dictionary.evaluari.administrareClienti}
                                             </Button>
                                                            </Grid>
                                                        }

                                                        {this.state.emailuriEvaluare.length > 0 &&
                                                            <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <span style={{ fontSize: 14 }}><span style={{ fontWeight: 600 }}>{this.state.emailuriEvaluare.length}</span>   {this.dictionary.evaluari.din10Evaluatori}</span>
                                                            </Grid>
                                                        }

                                                    </Grid>

                                                </Grid>

                                            </Grid>
                                        }


                                    </Grid>

                                }





                            </Grid>
                        }


                        {this.state.initiazaEvaluarea &&

                            <Grid style={{  padding: '0 40px 0 40px' }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <Grid container>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 style={{ textAlign: 'left', paddingLefft: 20, marginBottom: 5, color: '#19a63c',
                                                            fontSize: 16 }} >  {this.dictionary.evaluari.conditiiIndeplinite}</h5>
                                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span style={{ fontSize: 12 }}>{this.dictionary.evaluari.conditiiIndepliniteMesaj} 
                                            
                                            </span>

                                            <span style={{display:'block', marginTop:20, marginBottom:20, fontSize:12}}> {this.dictionary.evaluari.apasaButonulVerde}  <span style={{ fontWeight: 600 }}> {this.dictionary.evaluari.initiazaEvaluareaPentruADemara} </span></span>
                                        </Grid>

                                        {Number(this.state.tipEvaluare) === 2 && this.state.departamente[this.state.idxDepartament].angajati.map((a, idxA) => {
                                            return (
                                                <Grid key={idxA} item xs={5} sm={5} md={5} lg={5} xl={5}>

                                                    <Grid onClick={()=>{this.goToUser(a)}} container>
                                                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                            <div style={{paddingLeft:0}} className='pm-custom-user-select-option' style={{cursor:'pointer'}} >
                                                                <div>
                                                                    {
                                                                        a.poza &&
                                                                        <div
                                                                            className='pm-angajati-picture'
                                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + a.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                                        </div>
                                                                    }
                                                                    {!a.poza &&

                                                                        <Avatar
                                                                            className='pm-angajati-picture'
                                                                            style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(a.id) }}>
                                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                            {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                            <i className='material-icons'>person</i>
                                                                        </Avatar>
                                                                        // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                    }
                                                                    <span className='pm-custom-user-select-text'>{a.nume}</span>
                                                                </div>

                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    paddingRight: 3
                                                                }}>

                                                                </div>




                                                            </div>
                                                        </Grid>

                                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                            <i style={{ fontSize: 30, color: 'green' }} className='material-icons'>
                                                                check_circle_outline
                                                                     </i>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}

                                {Number(this.state.tipEvaluare) === 3 && this.state.useri.map((a, idxA) => {
                                            return (
                                                <Grid key={idxA} item xs={5} sm={5} md={5} lg={5} xl={5}>

                                                    <Grid onClick={()=>{this.goToUser(a)}} container>
                                                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                            <div style={{paddingLeft:0}} className='pm-custom-user-select-option' style={{cursor:'pointer'}} >
                                                                <div>
                                                                    {
                                                                        a.poza &&
                                                                        <div
                                                                            className='pm-angajati-picture'
                                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + a.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                                        </div>
                                                                    }
                                                                    {!a.poza &&

                                                                        <Avatar
                                                                            className='pm-angajati-picture'
                                                                            style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(a.id) }}>
                                                                            {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                            {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                            <i className='material-icons'>person</i>
                                                                        </Avatar>
                                                                        // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                    }
                                                                    <span className='pm-custom-user-select-text'>{a.nume}</span>
                                                                </div>

                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    paddingRight: 3
                                                                }}>

                                                                </div>




                                                            </div>
                                                        </Grid>

                                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                            <i style={{ fontSize: 30, color: 'green' }} className='material-icons'>
                                                                check_circle_outline
                                                                     </i>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </Grid>

                            </Grid>
                        }


                        {!this.state.initiazaEvaluarea &&
                            <Grid style={{ padding: '0px 40px 0px 40px' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                {this.state.userEvaluat.id !== null && Number(this.state.tipEvaluare) === 1 &&
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.dateAngajat}</h5>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.numeAngajat}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.nume}</span></span>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.functieAngajat}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.functie}</span></span>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.departament}: <span style={{ fontWeight: 600 }}>{this.state.userEvaluat.nume_departament}</span></span>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.colegiInDept}: <span style={{ fontWeight: 600 }}>{this.state.idxDepartament !== -1 ? this.state.departamente[this.state.idxDepartament].angajati.length : 0}</span></span>
                                        </Grid>



                                    </Grid>
                                }


                                {this.state.departamentSelectat !== 0 && Number(this.state.tipEvaluare) === 2 &&
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h5 className='evaluare-noua-subtitlu'  style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.dateDepartament}</h5>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.numeAngajat}: <span style={{ fontWeight: 600 }}>{this.state.departamente[this.state.idxDepartament].nume}</span></span>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.angajati}: <span style={{ fontWeight: 600 }}>{this.state.departamente[this.state.idxDepartament].angajati.length}</span></span>
                                        </Grid>




                                    </Grid>
                                }





                                {this.state.ultimaEvaluare &&
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.evaluari.ultimaEvaluare}</h5>
                                        </Grid>

                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.dataUltimaEvaluare}: <span style={{ fontWeight: 600 }}>{this.u.dataFull(this.u.ParseDataFromSql(this.state.ultimaEvaluare.cand_creat))}</span></span>
                                        </Grid>

                                        <Grid style={{ textAlign: 'left', fontSize: 12 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <span>{this.dictionary.evaluari.nrEvaluatori}: <span style={{ fontWeight: 600 }}>{this.state.ultimaEvaluare.nr_evaluatori}</span></span>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        }








                    </Grid>

                </Grid>
            </div >
        );
    }
}